module.exports = __webpack_public_path__ + "assets/img/wxewm.327d5083.png";